var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockOpen = function SvgLockOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6a2.5 2.5 0 1 1 5 0v2.25c0 .416.334.75.75.75s.75-.334.75-.75V6a4 4 0 1 0-8 0v2h-7.5c-1.103 0-2 .897-2 2v6c0 1.104.897 2 2 2h10c1.103 0 2-.896 2-2v-6c0-1.103-.897-2-2-2h-1zm-9 3.5h10c.275 0 .5.225.5.5v6c0 .275-.225.5-.5.5h-10a.5.5 0 0 1-.5-.5v-6c0-.275.225-.5.5-.5"
  })));
};
export default SvgLockOpen;